export const fontFamilies = {
  soehne: "'Soehne', sans-serif",
  soehneKraftig: "'Soehne Kraftig', sans-serif",
  soehneBreit: "'Soehne Breit', sans-serif",
  soehneMono: "'Soehne Mono', monospace",
} as const
